export default __webpack_public_path__ + "static/media/p1.d593a8d6.svg";